export default "__VITE_ASSET__Deoo1$ur__"